module.exports = __webpack_public_path__ + "static/media/LoginBanner6000X2400.3565e3c1.png";